import type { SVGComponentProps } from 'BreetHelpers';

export const ConvertIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M11.6173 15.5701C11.4748 15.5701 11.3323 15.5176 11.2198 15.4051C11.0023 15.1876 11.0023 14.8276 11.2198 14.6101L14.9773 10.8526C15.1948 10.6351 15.5548 10.6351 15.7723 10.8526C15.9898 11.0701 15.9898 11.4301 15.7723 11.6476L12.0148 15.4051C11.9023 15.5101 11.7598 15.5701 11.6173 15.5701Z'
			fill='white'
		/>
		<path
			d='M15.375 11.8047H2.625C2.3175 11.8047 2.0625 11.5497 2.0625 11.2422C2.0625 10.9347 2.3175 10.6797 2.625 10.6797H15.375C15.6825 10.6797 15.9375 10.9347 15.9375 11.2422C15.9375 11.5497 15.6825 11.8047 15.375 11.8047Z'
			fill='white'
		/>
		<path
			d='M2.62508 7.32008C2.48258 7.32008 2.34008 7.26758 2.22758 7.15508C2.01008 6.93758 2.01008 6.57758 2.22758 6.36008L5.98508 2.60258C6.20258 2.38508 6.56258 2.38508 6.78008 2.60258C6.99758 2.82008 6.99758 3.18008 6.78008 3.39758L3.02258 7.15508C2.91758 7.26008 2.76758 7.32008 2.62508 7.32008Z'
			fill='white'
		/>
		<path
			d='M15.375 7.32031H2.625C2.3175 7.32031 2.0625 7.06531 2.0625 6.75781C2.0625 6.45031 2.3175 6.19531 2.625 6.19531H15.375C15.6825 6.19531 15.9375 6.45031 15.9375 6.75781C15.9375 7.06531 15.6825 7.32031 15.375 7.32031Z'
			fill='white'
		/>
	</svg>
);
